import { FlexProps, SystemStyleObject } from '@chakra-ui/react';
import { faCheck, faClose } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '../../Icon/Icon';

export type CheckedListProps = FlexProps;

export const checkMark = <Icon icon={faCheck} color="green.800" size="lg" mt={0.5} />;
export const xMark = <Icon icon={faClose} color="red.800" size="lg" mt={0.5} />;

export const checkedListSx: SystemStyleObject = {
  listStyleType: 'none',
  flexDirection: 'column',
  gap: 4,
  '>li': {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 3,
  },
};
